import { render } from "./OverviewHeaderOpportunity.vue?vue&type=template&id=6e547616&scoped=true"
import script from "./OverviewHeaderOpportunity.vue?vue&type=script&lang=js"
export * from "./OverviewHeaderOpportunity.vue?vue&type=script&lang=js"

import "./OverviewHeaderOpportunity.vue?vue&type=style&index=0&id=6e547616&lang=scss&scoped=true"
import "./OverviewHeaderOpportunity.vue?vue&type=style&index=1&id=6e547616&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e547616"]])

export default __exports__